module.exports = __webpack_public_path__ + "img/medal.c8775ed1.svg";